<div class="lum-df-markdown-container" [innerHTML]="model.markdown || '' | markdown | async"></div>
